module.exports = __webpack_public_path__ + "img/login-v2.407ee90b.svg";